import React, { useState } from 'react';
import {
    Box,
    Button,
    Form,
    FormField,
    Heading,
    Spinner,
    Text,
    TextInput
} from 'grommet';
import http from './utils/http';
import SignUp from './SignUp';
import ProfileModel from './profiles/profile-model';
import adam from './profiles/adam';
import jackson from './profiles/jackson';
import shiv from './profiles/shiv';
import tom from './profiles/tom';
import doe from './profiles/doe';
const accounts = [adam, jackson, shiv, tom, doe];

const verifyLogIn = (username, password) => {
    let account = null;
    for (let i = 0; i < accounts.length; ++i) {
        if (username === accounts[i].username && password === accounts[i].password)
            account = accounts[i];
    }
    return account;
}

const SignIn = ({ setLoggedIn, setView, setUser }) => {
    const [ showSignUp, setShowSignUp ] = useState(false);
    const [ showFailedSignIn, setShowFailedSignIn ] = useState(false);
    const [ showFailedSignUp, setShowFailedSignUp ] = useState(false);
    const [ showSignInSpinner, setShowSignInSpinner ] = useState(false);

    const handleSignIn = async (formData) => {
        try {
            setShowSignInSpinner(true);
            console.log("trace: inside handleSignIn");
            // Call the registerUser function with the form data

            const loginResponse = await http.loginUser(formData);

            if (loginResponse.status) {
                // Registration successful
                setShowSignInSpinner(false);
                const user = new ProfileModel(formData);
                setUser(user);
                setView('analytics');
                setLoggedIn(true);
                setShowSignUp(false);
            } else {
                // Registration failed
                setShowSignInSpinner(false);
                setShowFailedSignIn(true);
                console.error('Login failed:', loginResponse.message);
                // Handle the error or show an error message to the user
            }
        } catch (error) {
            setShowSignInSpinner(false);
            setShowFailedSignIn(true);
            console.error('Error during Login:', error);
            // Handle other errors if needed
        }
    };

    return (
        <Box gap="medium" width="medium" alignSelf='center' margin={{vertical: 'large'}}>
            <Heading level={2} margin="none">
                Sign In
            </Heading>
            <Form onSubmit={({ value }) => handleSignIn(value)} onChange={() => setShowFailedSignIn(false)}>
                <FormField name="username" htmlFor="account-id">
                    <TextInput id="account-id" name="username" placeholder="Username"/>
                </FormField>
                <FormField name="password" htmlFor="password-id">
                    <TextInput id="password-id" name="password" placeholder="Password" type="password"/>
                </FormField>
                <Button primary label="Log In" type="submit"/>
                {
                    showSignInSpinner && (
                        <Box pad={{vertical: 'small'}}>
                            <Spinner alignSelf='center' size='medium' pad={{ vertical: 'small' }} />
                        </Box>
                    )
                }
                <Box pad={{ vertical: 'small' }}></Box>
                {showFailedSignIn && (
                    <Box>
                        <Text color='red'>Sign in failed</Text>
                        <Box pad={{ vertical: 'small' }}></Box>
                    </Box>
                )}
                <Box 
                    pad={{ vertical: 'medium' }}
                    border={{ side: 'top' }}
                >
                    <Button label="Sign Up" onClick={() => setShowSignUp(true)}/>
                </Box>
            </Form>
            {showSignUp && <SignUp setShowSignUp={setShowSignUp} setView={setView} setLoggedIn={setLoggedIn} setUser={setUser} />}
        </Box>
    )
}

export default SignIn;